import fetchWithTimeout from './fetchWithTimeout'
import constants from '../constants'

const getOkToShopInfo = async (ean) => {
  let result = null
  const config = window.__ENV__
  if (typeof ean !== 'undefined' && ean !== null && config.okToShopBaseUrl !== undefined) {
    const otsUrl = `${config.okToShopBaseUrl}?url=${window.location.href}&ean=${ean}`

    try {
      const okToShopInfo = await fetchWithTimeout(otsUrl, { timeout: constants.timeout.TEN_SECONDS })
      const jsonOKTS = await okToShopInfo.json()
      result = jsonOKTS && jsonOKTS.html ? jsonOKTS : null
    } catch (error) {
      result = null
    }
  }
  return result
}

export default getOkToShopInfo
